export const brand = `</> nicolasz.dev`;
